import { render, staticRenderFns } from "./CenterViewShippingAdd_Ap.vue?vue&type=template&id=4999080d&scoped=true"
import script from "./CenterViewShippingAdd_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewShippingAdd_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewShippingAdd_Ap.vue?vue&type=style&index=0&id=4999080d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999080d",
  null
  
)

export default component.exports